import { ConditionOperator, StringUtils } from "Global/Base/Utils/StringUtils";

export const CLASS_NAME = "SINotification";

export const ATTRIBUTE_ID = "ID";
export const ATTRIBUTE_FUNCTION = "Notification_func";
export const ATTRIBUTE_TITLE = "Title";
export const ATTRIBUTE_TEXT = "Text";
export const ATTRIBUTE_CREATED_DATE = "Created_date";
export const ATTRIBUTE_FORM_CODE = "Notification_form.Kod_formulare";
export const ATTRIBUTE_OBJECT_ID = "Obj_ID";
export const ATTRIBUTE_PENDING = "Pending";
export const ATTRIBUTE_TYPE_COLOR = "Notification_type.Color";
export const ATTRIBUTE_TYPE_ICON = "Notification_type.Icon";
export const ATTRIBUTE_TYPE_NAME = "Notification_type.Name";

export const ATTRIBUTES = [
    ATTRIBUTE_FUNCTION, ATTRIBUTE_TITLE, ATTRIBUTE_TEXT, ATTRIBUTE_CREATED_DATE, ATTRIBUTE_FORM_CODE, ATTRIBUTE_OBJECT_ID, ATTRIBUTE_PENDING,
    ATTRIBUTE_TYPE_COLOR, ATTRIBUTE_TYPE_ICON, ATTRIBUTE_TYPE_NAME,
];

export const ORDERING = [ "DESC Created_date" ];

export const GROUP_CLASS_NAME = "SNotification_group";
export const GROUP_ATTRIBUTES = ["Name", "ViewAllForm.kod_formulare", "Icon", "LocKey"];
export const GROUP_CONDITION = "ID <> 0";

export const NOTIFICATION_CONDITION = StringUtils.combineConditions(
    ConditionOperator.and,
    "ID <> 0",
    "Notification_user = null OR Notification_user.ID = $UserID",
    "Notification_type.Notification_type_group.Name = @0",
);

export const PENDING_NOTIFICATION_CONDITION = StringUtils.combineConditions(
    ConditionOperator.and,
    NOTIFICATION_CONDITION,
    "Pending = TRUE",
);
